<page-content>
  <ng-container *ngIf="myPackage?.ibexTablet">
    <div class="col">
      <mat-card appearance="outlined">
        <mat-card-title>{{'packages.ibexsmart.general' | translate}}</mat-card-title>
        <ng-container *ngFor="let key of generalFieldNames">
          <smart-input *ngIf="key !== 'matchIds'" [(model)]="myPackage" [hasTrash]="true" [key]="key" hintTranslationPrefix="packages.ibextablet.hints"
                       jsonPointerKey="/ibexTablet" translationPrefix="packages.ibextablet"></smart-input>
        </ng-container>
      </mat-card>
    </div>
    <div class="col">
      <mat-card appearance="outlined">
        <mat-card-title>{{'packages.ibexsmart.styling' | translate}}</mat-card-title>
        <ng-container *ngFor="let key of styleFieldNames">
          <smart-input *ngIf="key !== 'matchIds'" [(model)]="myPackage" [hasTrash]="true" [key]="key" hintTranslationPrefix="packages.ibextablet.hints"
                       jsonPointerKey="/ibexTablet" translationPrefix="packages.ibextablet"></smart-input>
        </ng-container>
      </mat-card>
    </div>
  </ng-container>
  <div class="button-right-container">
    <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{'general.save' | translate}}</button>
  </div>
</page-content>
